import { Button } from "@mui/material";
import React from "react";

interface TripIdCellRendererProps {
  displayValue: string;
  onClick: any;
}

export const TripIdCellRenderer: React.FC<TripIdCellRendererProps> = ({
  displayValue,
  onClick,
}) => {
  return (
    <Button
      onClick={onClick}
      style={{ textDecoration: "none", color: "#333333", fontSize: "14px" }}
    >
      {displayValue}
    </Button>
  );
};
